var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MultiFormulaColumn_1;
/* eslint-disable import/no-duplicates */
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-base-pipe'; // force import for JsonSchema
const schema = {
    $id: 'urn:wisepipe-common-pipe:MultiFormulaColumn',
    type: 'object',
    properties: {
        column: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable'
                },
                { type: 'string', minLength: 1, maxLength: 150 }
            ]
        },
        formula: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CompoundToolVariable' }, { type: 'string', minLength: 1 }]
        },
        columnToReplace: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                },
                { type: 'string', minLength: 1, maxLength: 150 }
            ]
        }
    },
    required: ['column', 'formula']
};
let MultiFormulaColumn = MultiFormulaColumn_1 = class MultiFormulaColumn {
    constructor(column, formula, columnToReplace) {
        this.column = column;
        this.formula = formula;
        if (columnToReplace !== undefined)
            this.columnToReplace = columnToReplace;
        JSON.validate(this, MultiFormulaColumn_1);
    }
    applyParameters(parameters) {
        const baseVals = this.getBaseValues(parameters);
        return new MultiFormulaColumn_1(baseVals.column, baseVals.formula, baseVals.columnToReplace);
    }
    getBaseValues(parameters) {
        return {
            column: parameters.getStrVal(this.column),
            formula: parameters.getStrVal(this.formula),
            columnToReplace: parameters.getStrOrUndefVal(this.columnToReplace)
        };
    }
};
MultiFormulaColumn = MultiFormulaColumn_1 = __decorate([
    JsonSchema(schema)
], MultiFormulaColumn);
export { MultiFormulaColumn };
//# sourceMappingURL=multiFormulaColumn.js.map